import { render, staticRenderFns } from "./Box4.vue?vue&type=template&id=393b148b&scoped=true&"
import script from "./Box4.vue?vue&type=script&lang=js&"
export * from "./Box4.vue?vue&type=script&lang=js&"
import style0 from "./Box4.vue?vue&type=style&index=0&id=393b148b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393b148b",
  null
  
)

export default component.exports